import CustomLabelEditingProvider from "./CustomLabelEditingProvider";

export default {
    __init__: ["labelEditingProvider"],
    labelEditingProvider: ["type", CustomLabelEditingProvider],
};
